/* ========================================================================
 *  module application help
 * ========================================================================
*/
FD.REPORT = (function ($, me) {
    'use strict';

    var child = me.REPORT || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_COMMON = '/Common/Report/';
    var URL_LEARNING = '/LearningSuite/';

    var MESSAGE_CONTAINER_ELEM = '[data-modalmessage="true"]';
    var FAVORITE_REPORTS_TAB = '#FAVORITE_REPORTS_TAB';
    var FAVORITE_REPORTS_FORM = '#FAVORITE_REPORTS_FORM';
    var SCHEDULED_REPORTS_TAB = '#SCHEDULED_REPORTS_TAB';
    var SCHEDULED_REPORTS_FORM = '#SCHEDULED_REPORTS_FORM';
    var FAVORITE_SELECT = '#FAVORITE_SELECT';
    var SCHEDULED_REPORTS = '#SCHEDULED_REPORTS';
    var FAVORITE_REPORTS = '#FAVORITE_REPORTS';
    var FREQUENCY_DAY = '#FREQUENCY_DAY';
    var ADD_OWNER_BOX = '#ADD_OWNER_BOX';
    var OWNER_LIST = '#OWNER_LIST';
    var RELATIVE_DATE_MODE = '#RELATIVE_DATE_MODE';
    var MODAL_ELEM = '#IS_MODAL';

    var recipients = [];
    var notify = new Notify();
    var label = '';
    var realDateQueryString = '';

    var entityTypes = {
        Cell: 2,
        Division: 3,
        Machine: 6,
        Part: 7,
        Station: 23,
        Substation: 24,
        ManualProcess: 25,
        FocusFactory: 36,
        Employee: 202,
        Company: 203,
        Origin: 301,
        ScrapIssue: 302,
        DowntimeIssue: 303,
        CR: 4,
        Building: 40,
        CUSTOM_USER_GROUP: -1,
        Playlist: -2
    };

    var frequencyType = {
        WEEKLY: 1,
        MONTHLY: 2
    };

    var relativeDateMode = {
        BY_DAY: 0,
        BY_WEEK: 1,
        BY_MONTH: 2,
        BY_QUARTER: 3,
        BY_YEAR: 4
    }

    var entityFilterType = {
        ALL_DIVISION_USERS: 1,
        ALL_CELL_USERS: 2,
        ALL_CR_USERS: 3,
        SINGLE_USER: 4,
        CR_OWNER: 5,
        DR_OWNER: 6,
        CELL_LEAD: 7,
        CUSTOM_USER_GROUP: 8,
        ALL_BOT_USERS: 9,
        BOT_CORPORATE: 10,
        BOT_DIVISION: 11,
        ALL_1PP_USERS: 12,
        ONEPP_CORPORATE: 13,
        ONEPP_DIVISION: 14,
        ALL_INNOTEC: 15
    };

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {
        COPY_FAVORITE: 19,
        SAVE_FAVORITE: 20,
        SELECT_FAVORITE: 21,
        DELETE_FAVORITE: 22,
        USE_RELATIVE_DATES: 23,
        RELATIVE_DATE_MODE: 24,

        SAVE_SCHEDULE: 25,
        SELECT_SCHEDULE: 26,
        DELETE_SCHEDULE: 27,
        ADD_OWNER: 340,
        DELETE_OWNER: 341,
        SELECT_ENTTIY_TYPE: 345,
        FREQUENCY_TYPE: 28,
    };


    /* ========================================================================
     *  object functions
     * ========================================================================
    */
    
    

    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */

    // save current settings as a favorite report
    function handleFavoriteCRUD(data) {
        if (!me.CONTROL.Validate(FAVORITE_REPORTS_FORM)) {
            return;
        }

        var frmElem = me.getFormFields(FAVORITE_REPORTS_FORM);
        frmElem.ViewID = data.e.closest("[data-parent=true]").parent().closest("[data-parent=true]").data("parentid");
        if (data.tag == tag.SAVE_FAVORITE) {
            frmElem.FavoriteID = data.parentid;
        }

        var options = {
            url: URL_COMMON + "HandleFavoriteCRUD",
            params: {
                item : frmElem
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnFavoriteListByUserID(result.data);
                returnScheduleListByUserID();
                returnFavoriteListByApplicationCode();

                notify.confirm(label["FavoriteSuccessfullySaved"]);
            }
        }
    }

    function handleFavoriteActiveCRUD(data) {
        var options = {
            url: URL_COMMON + "HandleFavoriteActiveCRUD",
            params: {
                ID: data.parentid,
                isActive: false
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnFavoriteListByUserID();
                returnScheduleListByUserID();
                returnFavoriteListByApplicationCode();
            }
        }
    }


    function handleScheduleCRUD(data) {

        if (!me.CONTROL.Validate(SCHEDULED_REPORTS_FORM)) {
            return;
        }
        if (recipients.length == 0) {
            notify.alert(label['YouMustSelectAtLeastOneRecipient']);
            return;
        }

        var frmElem = me.getFormFields(SCHEDULED_REPORTS_FORM);
        frmElem.EntityFilterList = recipients;
        frmElem.FrequencyDay = parseInt(parseInt(frmElem.FrequencyType) == 1 ? frmElem.FrequencyDayWeek : frmElem.FrequencyDayMonth);
        frmElem.ID = data.parentid;
        
        var options = {
            url: URL_COMMON + "HandleScheduleCRUD",
            params: {
                item: frmElem
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnFavoriteListByApplicationCode();
                returnScheduleListByUserID(result.data);
                notify.confirm(label["FavoriteSuccessfullyScheduled"]);
            }
        }
    }

    function handleScheduleDeleteCRUD(data) {
        var options = {
            url: URL_COMMON + "HandleScheduleDeleteCRUD",
            params: {
                ID: data.parentid
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnScheduleListByUserID();
                returnScheduleByID({ parentid: 0 });
                returnFavoriteListByApplicationCode();
            }
        }
    }


    function changeFrequencyType(data) {
        switch (parseInt(data.value)) {
            case frequencyType.WEEKLY:
                $("[data-fldname=FrequencyDayWeek]", SCHEDULED_REPORTS_TAB).toggleClass("hidden", false);
                $("[data-fldname=FrequencyDayMonth]", SCHEDULED_REPORTS_TAB).toggleClass("hidden", true).val(1);
                $(FREQUENCY_DAY, SCHEDULED_REPORTS_TAB).toggleClass("hidden", false);
                break;
            case frequencyType.MONTHLY:
                $("[data-fldname=FrequencyDayWeek]", SCHEDULED_REPORTS_TAB).toggleClass("hidden", true);
                $("[data-fldname=FrequencyDayMonth]", SCHEDULED_REPORTS_TAB).toggleClass("hidden", false);
                $(FREQUENCY_DAY, SCHEDULED_REPORTS_TAB).toggleClass("hidden", false);
                break;
            default:
                $(FREQUENCY_DAY, SCHEDULED_REPORTS_TAB).toggleClass("hidden", true);
                $("[data-fldname=FrequencyDayWeek],[data-fldname=FrequencyDayMonth]", SCHEDULED_REPORTS_TAB).toggleClass("hidden", true);
                break;
        }
    }


    function getPlaylistOwnerEntityOptions(data) {
        var ulElem = $('[data-filteroptions]', ADD_OWNER_BOX);
        if (+data.value === 0) {
            ulElem.html('');
            $("[data-tag=" + tag.ADD_OWNER + "]").addClass("disabled");
            return;
        }

        var options = {
            url: URL_LEARNING + "GetPlaylistOwnerEntityOptions",
            params: {
                entityType: +data.value,
                isEnroll: data.e.data('isenroll')
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                ulElem.html(result.data);
                me.CONTROL.setValidateContainer(ulElem);
                me.CONTROL.setAutoComplete(ulElem);
                me.CONTROL.setSelect(true, ulElem);
                me.CONTROL.setCheckBox(true, ulElem);
                me.setToolTip();
                $("[data-tag=" + tag.ADD_OWNER + "]").removeClass("disabled");
            }
        }
    }


    function getAdditionalFilterOptions(data) {
        var secondaryFilterList = data.e.closest('.box-content').find('[data-secondaryfilterlist]');
        switch (+data.value) {
            case entityFilterType.DR_OWNER:
            case entityFilterType.BOT_DIVISION:
            case entityFilterType.ONEPP_DIVISION:
                $('[data-secondaryfilterlist]').removeClass('hidden');
                $('[data-secondaryfilterlist] select').data('validate', true);
                me.CONTROL.setValidateContainer(secondaryFilterList);
                break;
            default:
                $('[data-secondaryfilterlist]').addClass('hidden');
                $('[data-secondaryfilterlist] select').data('validate', false);
                me.CONTROL.setValidateContainer(secondaryFilterList);
                break;
        }
    }


    function handleAddRecipient(data) {
        var parentBox = data.e.closest('.box');
        if (!me.CONTROL.Validate(parentBox)) {
            return;
        }
        var formFields = me.getFormFields(parentBox);
        formFields.SecondaryEntityID = +formFields.EntityFilterType === entityFilterType.DR_OWNER ||
            +formFields.EntityFilterType === entityFilterType.BOT_DIVISION ||
            +formFields.EntityFilterType === entityFilterType.ONEPP_DIVISION ? formFields.SecondaryEntityID : null;

        if (formFields.EntityType == entityTypes.CUSTOM_USER_GROUP) {
            formFields.CustomUserGroupName = $('[data-fldname="CustomUserGroupID"] option:selected', parentBox).text();
        } else {
            formFields.Name = $('[data-fldname="ID"]', parentBox).val();
        }
        formFields.SecondaryEntityName = $('[data-fldname="EntityFilterType"] option:selected', parentBox).text()

        recipients.push(formFields);

        returnRecipientList();
    }


    function handleRemoveRecipient(data) {
        var idx = data.e.closest('.list-group-item').index()
        recipients.splice(idx, 1);

        returnRecipientList();
    }


    function returnRecipientList() {

        var options = {
            url: URL_COMMON + "ReturnRecipientList",
            params: {
                entityFilterList: recipients,
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(OWNER_LIST).html(result.data);
                me.CONTROL.setButton(true, $(OWNER_LIST));
                $('input[data-fldname=EntityType]', SCHEDULED_REPORTS_FORM).val('').data('value', null).data('initial', null);
            }
        }
    }

    /* ========================================================================
        *  Partial Functions
        * ========================================================================
    */


    function returnFavoriteListByUserID(selectedID) {
        selectedID = selectedID || $(".list-group-item.active", FAVORITE_REPORTS).data("parentid");

        var options = {
            url: URL_COMMON + "ReturnFavoriteListByUserID",
            params: {
                viewID: $(".modal-dialog", MODAL_ELEM).data("parentid")
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(FAVORITE_REPORTS).html(result.data.FAVORITE_REPORTS);
                me.CONTROL.setButton(true, FAVORITE_REPORTS);

                if (!$(FAVORITE_SELECT).data('noedit')) {
                    $("option[value!='']", FAVORITE_SELECT).remove();
                    $.each(result.data.FAVORITE_SELECT, function () {
                        $(FAVORITE_SELECT).append($("<option>").val(this.ID).text(this.Name));
                    });
                }

                $(".list-group-item", FAVORITE_REPORTS).removeClass("active");
                $(".list-group-item[data-parentid=" + selectedID + "]", FAVORITE_REPORTS).addClass("active");
                $(FAVORITE_SELECT).val(selectedID);
            }
        }
    }


    function returnFavoriteByID(data) {
        var options = {
            url: URL_COMMON + "ReturnFavoriteByID",
            params: {
                ID: data.parentid,
                viewID: $(".modal-dialog", MODAL_ELEM).data("parentid")
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(FAVORITE_REPORTS_FORM).html(result.data);

                data.e.closest(".list-group-item").siblings().removeClass("active");
                data.e.closest(".list-group-item").addClass("active");

                me.CONTROL.setValidateContainer(MODAL_ELEM);
                me.CONTROL.setButton(true, FAVORITE_REPORTS_FORM);
                me.CONTROL.setSelect(true, FAVORITE_REPORTS_FORM);
                me.CONTROL.setText(true, FAVORITE_REPORTS_FORM);
                me.CONTROL.setCheckBox(true, FAVORITE_REPORTS_FORM);
                me.setToolTip();

                removeRelativeDates();
            }
        }
    }


    function returnScheduleListByUserID(selectedID) {
        selectedID = selectedID || $(".list-group-item.active", SCHEDULED_REPORTS).data("parentid");

        var options = {
            url: URL_COMMON + "ReturnScheduleListByUserID",
            params: {
                viewID: $(".modal-dialog", MODAL_ELEM).data("parentid")
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(SCHEDULED_REPORTS).html(result.data);
                me.CONTROL.setButton(true, SCHEDULED_REPORTS);

                $(".list-group-item", SCHEDULED_REPORTS).removeClass("active");
                $(".list-group-item[data-parentid=" + selectedID + "]", SCHEDULED_REPORTS).addClass("active");
            }
        }
    }


    function returnScheduleByID(data) {
        var options = {
            url: URL_COMMON + "ReturnScheduleByID",
            params: {
                ID: data.parentid,
                viewID: $(".modal-dialog", MODAL_ELEM).data("parentid")
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(SCHEDULED_REPORTS_FORM).html(result.data);
                recipients = JSON.parse(result.getResponseHeader('RecipientList'));

                $(".list-group-item", SCHEDULED_REPORTS).removeClass("active");
                if (data.e) {
                    data.e.closest(".list-group-item").addClass("active");
                }

                me.CONTROL.setValidateContainer(MODAL_ELEM);
                me.CONTROL.setButton(true, SCHEDULED_REPORTS_FORM);
                me.CONTROL.setSelect(true, SCHEDULED_REPORTS_FORM);
            }
        }
    }

    function returnFavoriteListByApplicationCode() {
        var options = {
            url: URL_COMMON + "ReturnFavoriteListByApplicationCode",
            params: {
                applicationCode: $(NAV_FAVORITE_LIST).data("appcode")
            },
            callback: afterData,
            ishtml: true,
            cancelprevious: true,
            delay: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(NAV_FAVORITE_LIST).html(result.data);
            }
        }
    }


    function applyRelativeDates() {
        var today = new Date();
        var frmElem = me.getFormFields(FAVORITE_REPORTS_FORM);
        var qsElem = $("[data-fldname=QueryString]", FAVORITE_REPORTS_FORM);

        if (frmElem.UseRelativeDates) {
            var qs = $(realDateQueryString.split("&")).map(function () {
                var parts = this.split("=");
                var date = new Date(parts[1]);
                var today = new Date(new Date().toDateString());
                if (parts[0].toLowerCase().indexOf("date") > -1 && parts[1].indexOf("/") > -1) {
                    switch (parseInt(frmElem.RelativeDateMode)) {
                        case relativeDateMode.BY_DAY:
                            parts[1] = date.getDaysBetween(today);
                            break;
                        case relativeDateMode.BY_WEEK:
                            var weeks = Math.floor(date.getFirstDayOfWeek().getDaysBetween(today.getFirstDayOfWeek()) / 7);
                            var offset = date.getDay();
                            parts[1] = weeks + ":" + offset;
                            break;
                        case relativeDateMode.BY_MONTH:
                            var months = date.getFirstDayOfMonth().getMonthsBetween(today.getFirstDayOfMonth());
                            var day = date.getDate();
                            if (day == date.getlastDayOfMonth()) {
                                day = 31;
                            }
                            parts[1] = months + ":" + day;
                            break;
                        case relativeDateMode.BY_YEAR:
                            var years = date.getYearFriendly() - today.getYearFriendly();
                            var month = date.getMonth() + 1;
                            var day = date.getDate();
                            if (day == date.getlastDayOfMonth()) {
                                day = 31;
                            }
                            parts[1] = years + ":" + month + ":" + day;
                            break;
                    }
                }
                return parts.join("=");
            });
            qsElem.val(qs.toArray().join("&"));
        } else {
            qsElem.val(realDateQueryString);
        }
    }

    function removeRelativeDates() {
        var frmElem = me.getFormFields(FAVORITE_REPORTS_FORM);
        if (frmElem.UseRelativeDates) {
            var qs = $(frmElem.QueryString.split("&")).map(function () {
                var parts = this.split("=");
                if (parts[0].toLowerCase().indexOf("date") > -1 && parts[1].indexOf("/") == -1) {
                    var offsetParts = parts[1].split(':').map(function (item) { return parseInt(item); });

                    switch (parseInt(frmElem.RelativeDateMode)) {
                        case relativeDateMode.BY_DAY:
                            parts[1] = new Date().adjustDayValue(offsetParts[0]).getDateFriendly();
                            break;
                        case relativeDateMode.BY_WEEK:
                            parts[1] = new Date().getFirstDayOfWeek().adjustDayValue(offsetParts[0] * 7 + offsetParts[1]).getDateFriendly();
                            break;
                        case relativeDateMode.BY_MONTH:
                            parts[1] = new Date().adjustMonthValue(offsetParts[0]).adjustDayValue(offsetParts[1]).getDateFriendly();
                            break;
                        case relativeDateMode.BY_YEAR:
                            parts[1] = new Date(new Date().getYearFriendly() + offsetParts[0], offsetParts[1] - 1, offsetParts[2]).getDateFriendly();
                            break;
                    }
                }
                return parts.join("=");
            });
            realDateQueryString = qs.toArray().join("&");
        } else {
            realDateQueryString = frmElem.QueryString;
        }
    }


    /* ========================================================================
     *  page init
     * ========================================================================
    */


    child.init = function () { };

    child.GetManageFavoriteScheduleModal = function (xhr) {
        label = me.getLabel();

        removeRelativeDates();
        applyRelativeDates();

        if (typeof me.PAGE.getAdditinalData == "function") {
            $("[data-fldname=ExtraData]", FAVORITE_REPORTS_FORM).val(JSON.stringify(FD.PAGE.getAdditinalData()));
        }
        recipients = [];
        me.AJAX.showModal(xhr);
    }

    //   after control event
    child.getAfterControlEvent = function (data) {
        switch (data.tag) {
            case tag.COPY_FAVORITE:
            case tag.SAVE_FAVORITE:
                handleFavoriteCRUD(data);
                break;
            case tag.SELECT_FAVORITE:
                returnFavoriteByID(data);
                break;
            case tag.DELETE_FAVORITE:
                handleFavoriteActiveCRUD(data);
                break;
            case tag.SAVE_SCHEDULE:
                handleScheduleCRUD(data);
                break;
            case tag.SELECT_SCHEDULE:
                returnScheduleByID(data);
                break;
            case tag.DELETE_SCHEDULE:
                handleScheduleDeleteCRUD(data);
                break;
            case tag.FREQUENCY_TYPE:
                changeFrequencyType(data);
                break;
            case tag.USE_RELATIVE_DATES:
                $(RELATIVE_DATE_MODE).attr('disabled', !data.value);
                applyRelativeDates(data);
                break;
            case tag.RELATIVE_DATE_MODE:
                applyRelativeDates(data);
                break;


            // Owner Entity/User List
            case tag.ADD_OWNER:
                handleAddRecipient(data);
                break;
            case tag.DELETE_OWNER:
                handleRemoveRecipient(data);
                break;
            case tag.SELECT_ENTTIY_TYPE:
                getPlaylistOwnerEntityOptions(data);
                break;
            case tag.SELECT_FILTER_TYPE:
                getAdditionalFilterOptions(data);
                break;
        }
    };

    return child;
}(jQuery, FD));



